import { useMemo } from 'react';
import I18n from 'I18n';
export const useFormulaFieldProperties = ({
  expressions,
  allAvailableColumns
}) => {
  return useMemo(() => {
    if (!expressions) {
      return {
        isFormulaFieldPropertiesLoading: false,
        rawFormulaFieldExpressions: [],
        formulaFieldPropertiesForDropdown: []
      };
    }
    const formulaFields = expressions.filter(expression => {
      var _expression$input;
      return ((_expression$input = expression.input) === null || _expression$input === void 0 ? void 0 : _expression$input.length) > 0;
    }).filter(expression => allAvailableColumns.some(column => column.field.name === expression.alias)).toArray();
    const formulaFieldProperties = formulaFields.length > 0 ? [{
      text: I18n.text('report-customization-components.customization-components.relational-report.formula-fields'),
      value: I18n.text('report-customization-components.customization-components.relational-report.formula-fields'),
      options: [...formulaFields.map(field => ({
        text: field.get('label'),
        value: `.${field.get('alias')}`,
        disabled: false
      }))]
    }] : [];
    return {
      isFormulaFieldPropertiesLoading: false,
      formulaFieldProperties,
      formulaFieldExpressions: formulaFields
    };
  }, [expressions, allAvailableColumns]);
};